import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import DispatchHours from "./DispatchHours";

const DispatchHoursPage = () => {
  return (
    <NavHeightAdjust>
      <DispatchHours />
    </NavHeightAdjust>
  );
};

export default DispatchHoursPage;
